@if (loadedError) {
<app-widgets-overlay [type]="loadedErrorReason"></app-widgets-overlay>
} @if (!loadedError && loaded && !data) {
<app-widgets-overlay type="no-match"></app-widgets-overlay>
} @if (loaded && data) {
<div class="widget-container d-flex flex-column">
    <div class="widget-container__object">
        @if (!noTitle) {
        <h1 class="widget-title align-self-center">
            {{ 'web.widget_total_points_' + type | translate }}
        </h1>
        }
        <div class="d-flex">
            @if (data?.home; as p) {
            <div class="widget-team mt-1 d-flex flex-column" data-cy="team">
                <div class="widget-team__name d-flex align-items-center">
                    <img
                        (error)="imageError($event)"
                        [attr.src]="p.image | responsive : 'participant' : 'medium'"
                        [alt]="p.name"
                        class="img-fluid app-cursor mr-1"
                    />
                    <div>{{ p.name }}</div>
                </div>
            </div>
            } @if (data?.away; as p) {
            <div class="widget-team mt-1 d-flex flex-column widget-team--second" data-cy="team">
                <div class="widget-team__name d-flex align-items-center justify-content-end">
                    <div>{{ p.name }}</div>
                    <img
                        (error)="imageError($event)"
                        [attr.src]="p.image | responsive : 'participant' : 'medium'"
                        [alt]="p.name"
                        class="img-fluid app-cursor ml-1"
                    />
                </div>
            </div>
            }
        </div>
        <div class="d-flex flex-column widget-form-participant-container">
            <div class="d-flex justify-content-between">
                <div class=" ">&nbsp;</div>
                <div class="widget-form-participant-text align-self-end">
                    {{ 'web.total_points_basket_normal_time' | translate }}
                    ({{ 'web.num_matches' | translate }} {{ num }})
                </div>
                <div class=" ">&nbsp;</div>
            </div>
            <div class="d-flex align-content-stretch widget-form-participant--big">
                <div class="widget-form-participant-bar widget-form-participant-bar--home" [style.width.%]="30">
                    <span class="widget-form-participant-bar--big2" data-cy="avg-home">{{
                        avgHome | number : '1.1-2'
                    }}</span>
                    <br />
                    {{ data?.home?.name }}
                </div>
                <div
                    class="widget-form-participant-bar widget-form-participant-bar--uni widget-form-participant-bar--big text-center"
                    data-cy="avg-total"
                >
                    {{ avgTotal | number : '1.1-2' }}
                </div>
                <div class="widget-form-participant-bar widget-form-participant-bar--away" [style.width.%]="30">
                    <span class="widget-form-participant-bar--big2" data-cy="avg-away">{{
                        avgAway | number : '1.1-2'
                    }}</span>
                    <br />
                    {{ data?.away?.name }}
                </div>
            </div>
        </div>
        <div class="d-flex widget-form-participant-container">
            <div class="flex-fill">
                <h2 class="text-center widget-form-participant-container-h2">{{ 'web.over' | translate }}</h2>
                @for (uo of uoData; track $index) {
                <div data-cy="uo-item-over">
                    <div class="d-flex">
                        <div
                            class="widget-form-participant-bar widget-form-participant-bar--home"
                            [style.width.%]="width('home', uo)"
                        >
                            {{ getPrct('home', uo) }}%
                        </div>
                        <div
                            class="widget-form-participant-bar widget-form-participant-bar--away"
                            [style.width.%]="width('away', uo)"
                        >
                            {{ getPrct('away', uo) }}%
                        </div>
                    </div>
                    <div class="text-center widget-form-participant-container-under-text">+ {{ uo }}</div>
                </div>
                }
            </div>
            <div style="width: 4px">&nbsp;</div>
            <div class="flex-fill">
                <h2 class="text-center widget-form-participant-container-h2">{{ 'web.under' | translate }}</h2>
                @for (uo of uoData; track $index) {
                <div data-cy="uo-item-under">
                    <div class="d-flex">
                        <div
                            class="widget-form-participant-bar widget-form-participant-bar--home"
                            [style.width.%]="width('home', uo, 'under')"
                        >
                            {{ getPrct('home', uo, 'under') }}%
                        </div>
                        <div
                            class="widget-form-participant-bar widget-form-participant-bar--away"
                            [style.width.%]="width('away', uo, 'under')"
                        >
                            {{ getPrct('away', uo, 'under') }}%
                        </div>
                    </div>
                    <div class="text-center widget-form-participant-container-under-text">- {{ uo }}</div>
                </div>
                }
            </div>
        </div>
        <div class="w-100 text-center widget-form-participant-text app-word-nowrap">
            {{ 'web.num_of_matches' | translate }} ({{ num }})
        </div>
        <div class="widget-logo d-flex justify-content-center mt-4">
            <img
                [src]="'/img/' + client.getName() + '.png'"
                [alt]="client.getName()"
                data-cy="logo"
                class="widget-logo-client"
            />
        </div>
    </div>
</div>
}
